import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/welcome/welcome2.webp'


const _withScopeId = n => (_pushScopeId("data-v-e1f4ab8e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scroll-area container-fluid" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "d-block mx-auto welcome",
  src: _imports_0
}, null, -1))
const _hoisted_3 = { class: "h1 mb-3 text-center" }
const _hoisted_4 = { class: "mb-5 text-center" }
const _hoisted_5 = { class: "visually-hidden" }
const _hoisted_6 = { class: "invalid-feedback" }
const _hoisted_7 = { class: "visually-hidden" }
const _hoisted_8 = { class: "invalid-feedback" }
const _hoisted_9 = { class: "visually-hidden" }
const _hoisted_10 = { class: "invalid-feedback" }
const _hoisted_11 = { class: "form-check-label mt-3 d-flex" }
const _hoisted_12 = { class: "flex-grow-1" }
const _hoisted_13 = { class: "invalid-feedback" }
const _hoisted_14 = { class: "mt-5" }
const _hoisted_15 = {
  class: "mx-auto d-block btn btn-rounded btn-dark",
  type: "onSubmit"
}
const _hoisted_16 = { class: "gap-1 text-md-end mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Forward = _resolveComponent("Forward")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Form, {
      onSubmit: _ctx.onSubmit,
      "validation-schema": _ctx.schema,
      class: "form-vertical form-signup my-auto"
    }, {
      default: _withCtx(({ errors }) => [
        _hoisted_2,
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.t('heading')), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.t('required')), 1),
        _createElementVNode("label", _hoisted_5, _toDisplayString(_ctx.t('email')), 1),
        _createVNode(_component_Field, {
          name: "email",
          type: "text",
          class: _normalizeClass(["form-control", { 'is-invalid': errors.email }]),
          id: "email",
          modelValue: _ctx.form.email,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.email) = $event)),
          required: "",
          autofocus: "",
          placeholder: _ctx.t('email')
        }, null, 8, ["class", "modelValue", "placeholder"]),
        _createElementVNode("div", _hoisted_6, _toDisplayString(errors.email), 1),
        _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.t('password')), 1),
        _createVNode(_component_Field, {
          name: "password",
          type: "password",
          class: _normalizeClass(["form-control", { 'is-invalid': errors.password }]),
          id: "password",
          modelValue: _ctx.form.password,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.password) = $event)),
          placeholder: _ctx.t('password')
        }, null, 8, ["class", "modelValue", "placeholder"]),
        _createElementVNode("div", _hoisted_8, _toDisplayString(errors.password), 1),
        _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.t('repeat-password')), 1),
        _createVNode(_component_Field, {
          name: "password2",
          type: "password",
          class: _normalizeClass(["form-control", { 'is-invalid': errors.password2 }]),
          id: "password2",
          modelValue: _ctx.form.password2,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.password2) = $event)),
          placeholder: _ctx.t('repeat-password')
        }, null, 8, ["class", "modelValue", "placeholder"]),
        _createElementVNode("div", _hoisted_10, _toDisplayString(errors.password2), 1),
        _createElementVNode("label", _hoisted_11, [
          _createVNode(_component_Field, {
            name: "acceptTerms",
            modelValue: _ctx.form.acceptTerms,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.acceptTerms) = $event)),
            type: "checkbox",
            id: "acceptTerms",
            value: "true",
            class: _normalizeClass(["form-check-input flex-grow-0 me-3", { 'is-invalid': errors.acceptTerms }])
          }, null, 8, ["modelValue", "class"]),
          _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.t('terms')), 1)
        ]),
        _createElementVNode("div", _hoisted_13, _toDisplayString(errors.acceptTerms), 1),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("button", _hoisted_15, [
            _createTextVNode(_toDisplayString(_ctx.t('register')) + " ", 1),
            _createVNode(_component_Forward, { class: "forward" })
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createTextVNode(_toDisplayString(_ctx.t('q')) + " ", 1),
          _createVNode(_component_router_link, {
            class: "ms-2 text-uppercase",
            to: "/login"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('signin')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["onSubmit", "validation-schema"])
  ]))
}